<template>
  <div class="authTemplate">
    <preload-content :loading="loading">
  <div class="round_1"></div>
    <div class="round_2"></div>
    <div class="auth_container">
      <router-link to="/" class="logo">
        <img src="../../../../assets/images/header/logo.svg" alt="">
      </router-link>
    <h1>Регистрация</h1>
    <p style="text-align: center">Введите код из СМС</p>
    <div style="margin-bottom: 30px">
      <div class="inputs">
        <input
            :ref="`inp_${idx}`"
            type="text"
            :class="{inputed: inputValues[idx]}"
            maxlength="1"
            v-model="inputValues[idx]"
            v-for="(_, idx) in inputValues"
            :key="idx"
            @keyup="e => inputValidate(e, idx)"
        >
      </div>
      <error-text :text="errors.code" style="margin-bottom: 10px"/>
    </div>
    <button-component v-if="showTimer()" :thin="true">Отправить код повторно ({{ time }})</button-component>
    <button-component v-else @click="resendCode()">Отправить код повторно</button-component>
    </div>
    </preload-content>
  </div>
</template>

<script>
import ErrorText from "@/components/ui/text/error-text";

import ButtonComponent from '../../../../components/ui/buttons/button-component'
import {mapGetters, mapMutations} from "vuex";
import preloadContent from "@/components/ui/preload-content";

export default {
  name: 'Register_Confirm',
  components: {ButtonComponent,preloadContent, ErrorText},
  props: {
    openLogin: Function
  },
  data: () => ({
    time: null,
    loading: false,
    endTimer: null,
    inputValues: ['', '', '', ''],
    errors: {},
  }),
  mounted() {
    this.startTimer();
    this.$eventHub.$on('client.create.modal.set', (id) => {
      this.userId = id;
    });
        },
  methods: {
    ...mapGetters(['getRegisterData']),
    ...mapMutations(['openModal', 'closeModals', 'setRegisterData']),

    timer() {
      let timer = setInterval(() => {
        this.time = this.$moment.utc((this.$moment(this.endTimer).diff(this.$moment(), 'seconds')) * 1000).format('m:ss');
        if (this.time === '0:00') clearInterval(timer);
      }, 1000);
    },
    startTimer() {
      this.time = '2:00';
      this.endTimer = this.$moment().add(121, 'seconds');
      this.timer();
    },
    showTimer() {
      return this.time && this.time !== '0:00';
    },

    resendCode() {
      this.$api.admin.clientResend({id:this.userId}).finally(()=>{this.startTimer()});
    },
    confirmCode(code) {
      this.loading = true;
        this.$api.admin.clientVerify({id: this.userId, code: code})
            .then(() => {
              this.closeModals();
              this.$toast.success('Подтверждено!');
            }).catch(({response}) => this.errors = response.data.errors).finally(() => this.loading = false);
    },


    inputValidate(e, idx) {
      this.errors.code = null;
      if (e.code === 'Backspace' && idx > 0) {
        this.$refs[`inp_${--idx}`][0].focus()
      }
      else {
        if (idx < 3) {
          setTimeout(() => {
            this.$refs[`inp_${++idx}`][0].focus()
          }, 0)
        }
      }
      const value = this.inputValues.join('')
      if (value.length === 4) {
        this.confirmCode(value);
      }
    }
  },
  beforeDestroy () {
    this.$eventHub.$off('client.create.modal.set');
  }
}
</script>

<style scoped lang="scss">

.authTemplate {
  max-width: 400px;
  width: 100%;
  background-color: #fff;
  overflow: hidden;
  position: relative;
  height: 100vh;
  max-height: 800px;
  border-radius: 10px;

  .round_1, .round_2 {
    pointer-events: none;
    z-index: 1;
    position: absolute;
    opacity: 0.3;
    border-radius: 50%;
  }

  .round_1 {
    background: #FFD2B4;
    width: 400px;
    height: 400px;
    left: -276px;
    top: -249px;
  }

  .round_2 {
    background: #97C1BF;
    width: 200px;
    height: 200px;
    bottom: -84px;
    right: -126px;
  }

  .auth_container {
    position: relative;
    height: calc(100% - 50px);
    z-index: 2;
    max-width: 330px;
    padding: 0 15px 125px 15px;
    margin: 0 auto;

    h1 {
      font-weight: 600;
      font-size: 32px;
      line-height: 1.25;
      text-align: center;
      color: #383838;
      margin-bottom: 50px;
      padding-top: 0;
    }
  }

  .logo {
    display: block;
    width: 184px;
    height: 60px;
    margin: 50px auto 80px auto;
  }

  .bottom {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 30px;
    text-align: center;

    p {
      font-size: 14px;
      line-height: 1.71;
      color: #808080;
      margin-bottom: 10px;
    }

    a {
      font-weight: 600;
      font-size: 16px;
      line-height: 1.5;
      color: #B9765B;
      text-decoration: none;
    }
  }
}

@media screen and (max-width: 576px){
  .authTemplate {
    position: absolute;
    height: auto;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    max-width: 100%;
    max-height: 100%;
  }
}

.inputs {
  display: flex;
  margin: 25px -10px 10px -10px;

  input {
    width: 60px;
    height: 80px;
    margin: 0 10px;
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    color: #383838;
    border: 1px solid #E5E5E5;
    border-radius: 5px;

    &.inputed {
      border: none;
      background: #DBBFA7;
      border-radius: 5px;
    }
  }
}
</style>
